// Initialize IndexedDB
const initDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("propertyDB", 1);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("properties")) {
        db.createObjectStore("properties", { keyPath: "id" });
      }
    };
  });
};

// Store data in IndexedDB
export const storeInIndexedDB = async (data) => {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(["properties"], "readwrite");
    const store = transaction.objectStore("properties");
    const request = store.put({ id: "cachedProperties", data });

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

// Get data from IndexedDB
export const getFromIndexedDB = async () => {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(["properties"], "readonly");
    const store = transaction.objectStore("properties");
    const request = store.get("cachedProperties");

    request.onsuccess = () => resolve(request.result?.data);
    request.onerror = () => reject(request.error);
  });
};

// Clear IndexedDB
export const clearIndexedDB = async () => {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(["properties"], "readwrite");
    const store = transaction.objectStore("properties");
    const request = store.clear();

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};
